import { planEatApi } from "../../../../planEatApi/PlanEatApi";
import { IEaterGroupContent } from "../../../../planEatApi/PlanEatFacade";
import { VersionsPage } from "../../components/VersionsPage";

export const VersionsForEaterGroup: React.FC = () => (
    <VersionsPage<IEaterGroupContent>
        section="eaterGroups"
        label="Eater group"
        idParam="eaterGroupId"
        getVersions={planEatApi.getVersionsForEaterGroup}
        nameOf={eaterGroup => eaterGroup.eaterGroupName}
        parentsOf={eaterGroup => ({ officeId: eaterGroup.officeId })}
    />
);
